import React from 'react';
import PropTypesConfig from 'config/prop-types';
import { ThemeProvider } from 'styled-components';
import slugify from 'util/slugify';

// Components.
import MeasureCard from 'components/measureCard';
import RaceCard from 'components/raceCard';

// Styled components.
import theme from 'styles/theme';
import styles from './styles';

/**
 * A component representing a results card for a race.
 */
export default class RaceGroup extends React.PureComponent {
  /**
   * Set PropTypes for this component.
   * @type {object}
   */
  static propTypes = PropTypesConfig.GROUP_SHAPE;

  render() {
    // Race Styled Components.
    const {
      GroupTitle,
      GroupWrapper,
    } = styles;

    const {
      title,
      results = [],
    } = this.props;

    return (
      <ThemeProvider theme={theme}>
        <GroupWrapper id={slugify(title)}>
          {title && (
            <GroupTitle>
              {title}
            </GroupTitle>
          )}
          {results.map((result) => {
            switch (result.type) {
              case 'measure':
                return (
                  <MeasureCard
                    key={JSON.stringify(result)}
                    {...result}
                  />
                );
              case 'race':
                return (
                  <RaceCard
                    key={JSON.stringify(result)}
                    {...result}
                  />
                );
              default:
                return null;
            }
          })}
        </GroupWrapper>
      </ThemeProvider>
    );
  }
}
